import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import { UserContainer } from "@/screens/SystemAdmin/containers"

export const Route = createFileRoute("/app/admin/system-admin/users/$userId")({
  parseParams: (params) => ({
    userId: z.string().parse(params.userId),
  }),
  component: UserContainer,
})
